import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";
import { APIErrorResponse } from "src/types/generic";

export const useGetProfile = () =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-user-profile"],
    queryFn: async () => {
      return apiClient.get(`/api/user/profile`);
    },
  });
